import React from 'react';
import { NewVMStep2SC } from './NewVMStep2.style';
import WorldwideCloudRegion from 'components/vm-deployment/worldwide-cloud-region';
import ErrorMessage from 'components/error-message';
import { StepDescription } from 'assets/css/common-styles';
import Heading from 'components/Heading/Heading';

const NewVMStep2 = ({ regionsData, formikProp, categoryID, sizeData, cpugen }) => {
  return (
    <NewVMStep2SC id="ST2">
      <Heading name={'vs/instance/create.step2_string2'}>
        <StepDescription />
        <WorldwideCloudRegion
          regionsData={regionsData}
          formikProp={formikProp}
          categoryID={categoryID}
          sizeData={sizeData}
          cpugen={cpugen}
        />
        {formikProp.errors.region && formikProp.touched.region && <ErrorMessage />}
      </Heading>
    </NewVMStep2SC>
  );
};

export default NewVMStep2;
